const trackUser = ({ event, loginMethod, userId, originId, origenParsed, seccion }) => {
    let data = {
        event,
        loginMethod,
        userId,
        originId,
        origenParsed,
        seccion
    };
    window.dataLayer.push(data);
}

export default {
    trackUser
}